import { IconProps } from "../../models/Icon";

export function CreditCardIcon({ size = 20, color = "#000", opacity = "1" }: IconProps) {
  return (
    <svg width={size} height={size} opacity={opacity} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.9 0.5H2.1C0.9345 0.5 0.0105 1.44563 0.0105 2.625L0 15.375C0 16.5544 0.9345 17.5 2.1 17.5H18.9C20.0655 17.5 21 16.5544 21 15.375V2.625C21 1.44563 20.0655 0.5 18.9 0.5ZM18.9 15.375H2.1V9H18.9V15.375ZM18.9 4.75H2.1V2.625H18.9V4.75Z" fill="#3D485C" />
    </svg>
  )
}





